import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const TruckIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M14 16V5H3.5C2.67 5 2 5.67 2 6.5V16H4.5" />

		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M14 8H18.2C18.72 8 19.2 8.27 19.47 8.71L21.78 12.4C21.92 12.63 22 12.9 22 13.17V16H19.5"
		/>

		<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M14.5 16H9.5" />

		<path
			opacity={0.4}
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M9 17.5C9 18.6 8.1 19.5 7 19.5C5.9 19.5 5 18.6 5 17.5C5 16.4 5.9 15.5 7 15.5C8.1 15.5 9 16.4 9 17.5Z"
		/>

		<path
			opacity={0.4}
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M19 17.5C19 18.6 18.1 19.5 17 19.5C15.9 19.5 15 18.6 15 17.5C15 16.4 15.9 15.5 17 15.5C18.1 15.5 19 16.4 19 17.5Z"
		/>
	</SvgIcon>
)

export default TruckIconAtom
